import { render } from "./Elaborazioni.vue?vue&type=template&id=2a15dd18"
import script from "./Elaborazioni.vue?vue&type=script&lang=js"
export * from "./Elaborazioni.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__